module.exports = __webpack_public_path__ + "img/oxford3.be5efc2e.png";